import { render } from "./appMain.vue?vue&type=template&id=cfdbb89c&scoped=true&ts=true"
import script from "./appMain.vue?vue&type=script&lang=ts"
export * from "./appMain.vue?vue&type=script&lang=ts"

import "./appMain.vue?vue&type=style&index=0&id=cfdbb89c&lang=scss&scoped=true"

import exportComponent from "E:\\bjft\\bjft-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfdbb89c"]])

export default __exports__